/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getOperationTheatres } from 'app/entities/operation-theatre/operation-theatre.reducer';
import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { CalendarStatus } from 'app/shared/model/enumerations/calendar-status.model';
import { AllottedByType } from 'app/shared/model/enumerations/allotted-by-type.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './surgical-appointment.reducer';

export const SurgicalAppointmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const operationTheatres = useAppSelector(state => state.operationTheatre.entities);
  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const surgicalAppointmentEntity = useAppSelector(state => state.surgicalAppointment.entity);
  const loading = useAppSelector(state => state.surgicalAppointment.loading);
  const updating = useAppSelector(state => state.surgicalAppointment.updating);
  const updateSuccess = useAppSelector(state => state.surgicalAppointment.updateSuccess);
  const calendarStatusValues = Object.keys(CalendarStatus);
  const allottedByTypeValues = Object.keys(AllottedByType);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/surgical-appointment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getOperationTheatres({}));
    dispatch(getPatientProcedures({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.actualStartTime !== undefined && typeof values.actualStartTime !== 'number') {
      values.actualStartTime = Number(values.actualStartTime);
    }
    if (values.actualEndTime !== undefined && typeof values.actualEndTime !== 'number') {
      values.actualEndTime = Number(values.actualEndTime);
    }
    if (values.plannedStartTime !== undefined && typeof values.plannedStartTime !== 'number') {
      values.plannedStartTime = Number(values.plannedStartTime);
    }
    if (values.plannedEndTime !== undefined && typeof values.plannedEndTime !== 'number') {
      values.plannedEndTime = Number(values.plannedEndTime);
    }
    if (values.bookedDate !== undefined && typeof values.bookedDate !== 'number') {
      values.bookedDate = Number(values.bookedDate);
    }
    if (values.cancelledDate !== undefined && typeof values.cancelledDate !== 'number') {
      values.cancelledDate = Number(values.cancelledDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...surgicalAppointmentEntity,
      ...values,
      theatre: operationTheatres.find(it => it.id.toString() === values.theatre?.toString()),
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'PLANNED',
          bookedByType: 'MANAGER',
          cancelledByType: 'MANAGER',
          handedOverToType: 'ACCOUNTANT',
          takenOverByType: 'ACCOUNTANT',
          ...surgicalAppointmentEntity,
          theatre: surgicalAppointmentEntity?.theatre?.id,
          surgery: surgicalAppointmentEntity?.surgery?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.surgicalAppointment.home.createOrEditLabel" data-cy="SurgicalAppointmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.surgicalAppointment.home.createOrEditLabel">
              Create or edit a SurgicalAppointment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="surgical-appointment-id"
                  label={translate('tinyMedicRestApp.surgicalAppointment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.actualStartTime')}
                id="surgical-appointment-actualStartTime"
                name="actualStartTime"
                data-cy="actualStartTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.actualEndTime')}
                id="surgical-appointment-actualEndTime"
                name="actualEndTime"
                data-cy="actualEndTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.plannedStartTime')}
                id="surgical-appointment-plannedStartTime"
                name="plannedStartTime"
                data-cy="plannedStartTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.plannedEndTime')}
                id="surgical-appointment-plannedEndTime"
                name="plannedEndTime"
                data-cy="plannedEndTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.status')}
                id="surgical-appointment-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {calendarStatusValues.map(calendarStatus => (
                  <option value={calendarStatus} key={calendarStatus}>
                    {translate(`tinyMedicRestApp.CalendarStatus.${calendarStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.bookedDate')}
                id="surgical-appointment-bookedDate"
                name="bookedDate"
                data-cy="bookedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.cancelledDate')}
                id="surgical-appointment-cancelledDate"
                name="cancelledDate"
                data-cy="cancelledDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.bookedByType')}
                id="surgical-appointment-bookedByType"
                name="bookedByType"
                data-cy="bookedByType"
                type="select"
              >
                {allottedByTypeValues.map(allottedByType => (
                  <option value={allottedByType} key={allottedByType}>
                    {translate(`tinyMedicRestApp.AllottedByType.${allottedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.bookedById')}
                id="surgical-appointment-bookedById"
                name="bookedById"
                data-cy="bookedById"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.cancelledByType')}
                id="surgical-appointment-cancelledByType"
                name="cancelledByType"
                data-cy="cancelledByType"
                type="select"
              >
                {allottedByTypeValues.map(allottedByType => (
                  <option value={allottedByType} key={allottedByType}>
                    {translate(`tinyMedicRestApp.AllottedByType.${allottedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.cancelledById')}
                id="surgical-appointment-cancelledById"
                name="cancelledById"
                data-cy="cancelledById"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.active')}
                id="surgical-appointment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.cursor')}
                id="surgical-appointment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.lastupdated')}
                id="surgical-appointment-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.microSec')}
                id="surgical-appointment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.timestampentry')}
                id="surgical-appointment-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.notes')}
                id="surgical-appointment-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.considerOnArrival')}
                id="surgical-appointment-considerOnArrival"
                name="considerOnArrival"
                data-cy="considerOnArrival"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.handedOverToId')}
                id="surgical-appointment-handedOverToId"
                name="handedOverToId"
                data-cy="handedOverToId"
                type="text"
              />
              <UncontrolledTooltip target="handedOverToIdLabel">
                <Translate contentKey="tinyMedicRestApp.surgicalAppointment.help.handedOverToId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.handedOverToType')}
                id="surgical-appointment-handedOverToType"
                name="handedOverToType"
                data-cy="handedOverToType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="handedOverToTypeLabel">
                <Translate contentKey="tinyMedicRestApp.surgicalAppointment.help.handedOverToType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.takenOverById')}
                id="surgical-appointment-takenOverById"
                name="takenOverById"
                data-cy="takenOverById"
                type="text"
              />
              <UncontrolledTooltip target="takenOverByIdLabel">
                <Translate contentKey="tinyMedicRestApp.surgicalAppointment.help.takenOverById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.surgicalAppointment.takenOverByType')}
                id="surgical-appointment-takenOverByType"
                name="takenOverByType"
                data-cy="takenOverByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="takenOverByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.surgicalAppointment.help.takenOverByType" />
              </UncontrolledTooltip>
              <ValidatedField
                id="surgical-appointment-theatre"
                name="theatre"
                data-cy="theatre"
                label={translate('tinyMedicRestApp.surgicalAppointment.theatre')}
                type="select"
                required
              >
                <option value="" key="0" />
                {operationTheatres
                  ? operationTheatres.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="surgical-appointment-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.surgicalAppointment.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/surgical-appointment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SurgicalAppointmentUpdate;
